import { render, staticRenderFns } from "./AddTherapies.vue?vue&type=template&id=081882ec&scoped=true&"
import script from "./AddTherapies.vue?vue&type=script&lang=js&"
export * from "./AddTherapies.vue?vue&type=script&lang=js&"
import style0 from "./AddTherapies.vue?vue&type=style&index=0&lang=less&"
import style1 from "./AddTherapies.vue?vue&type=style&index=1&lang=less&"
import style2 from "./AddTherapies.vue?vue&type=style&index=2&id=081882ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081882ec",
  null
  
)

export default component.exports